import { Grid, Pagination, PaginationItem } from '@mui/material';
import { WsTypoColors, WsTypoVariants, WsTypography } from 'wisestep-base';

interface INotesPaginationProps {
  totalCount: number;
  page: number;
  setPage: (page: number) => void;
  isTitle?: boolean;
}

const NotesPagination = ({ totalCount, page, setPage, isTitle }: INotesPaginationProps) => {
  const itemsPerPage = 20;
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  return (
    <Grid container px={2} pt={1} justifyContent="space-between" alignItems="center">
      <Grid item>
        {isTitle && (
          <WsTypography
            color={WsTypoColors.BLACK}
            variant={WsTypoVariants.TITLE}
            bold
            cursor="pointer"
          >
            {`Notes (${totalCount})`}
          </WsTypography>
        )}
      </Grid>
      <Grid item>
        <Grid container justifyContent="flex-end" alignItems="center">
          <Grid item>
            <WsTypography
              variant={WsTypoVariants.BODY1}
              color={WsTypoColors.BLACK}
              cursor={'pointer'}
            >
              {`${page * itemsPerPage + 1} - ${
                totalCount >= (page + 1) * itemsPerPage ? (page + 1) * itemsPerPage : totalCount
              } of ${totalCount}`}
            </WsTypography>
          </Grid>
          <Grid item>
            <Pagination
              count={totalPages}
              page={page + 1}
              onChange={(e, num) => {
                num > 0 ? setPage(num - 1) : setPage(num);
              }}
              renderItem={(item) => {
                if (item.type === 'previous' || item.type === 'next') {
                  return <PaginationItem {...item} />;
                }
                return null;
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NotesPagination;
